/**
 * Axios文档: https://www.kancloud.cn/yunye/axios/234845
 */

import axios from 'axios'
import { stringify } from 'qs'
import { Dialog, MessageBox } from 'element-ui'

export const API_URL = process.env.VUE_APP_API_BASE

const isDEV = process.env.NODE_ENV === 'development'
const service = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  transformRequest: [data => stringify(data)],
  // 携带cookie
  withCredentials: true
})
export default service

let loading = null

/**
 * POST请求
 * @param {String} apiName 接口do=后面的参数，表示接口的名称
 * @param {Object} data 请求参数
 * @param {Boolean} clear 是否清除data中为空字符串的字段
 */
export function post(apiName, data={}, clear=true) {
  return service.request({
    data: clear ? clearData(data) : data,
    params: { do: apiName },
    method: 'post',
  })
}

// 弹出Loading黑名单
// const REQUEST_LOADING_BLACK_LIST = [
// ]

// 请求拦截器
service.interceptors.request.use(
  config => {
    return config
  }
)

// 返回8684不需要理的接口名单
const RESPONSE_WHITE_LIST = [
  
]

// 响应拦截器
service.interceptors.response.use(
  response => {
    const { data } = response
    
    let apiName = response.config.params.do

    loading && loading.close();

    // 登录失效
    if (data.error_code == 8684 && !RESPONSE_WHITE_LIST.includes(apiName)) {
      
      // store.dispatch('FedLogout')

      MessageBox.confirm('登录后即可使用该功能', '提示', {
        confirmButtonText: '立即登录',
        showCancelButton: false,
        closeOnClickModal: false,
        showClose:false,
        type: 'warning'
      }).then(() => {
        location.href = `//fx.quzao.com/#/login?ref=${location.href}`
        // router.replace('/login')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
 
      
      Dialog.alert({
        message: '登录后即可使用该功能',
        confirmButtonText: '立即登录',
        showCancelButton: false,
        showClose:false,
      }).then(() => {
        location.href = `//fx.quzao.com/#/login?ref=${location.href}`
        // router.replace('/login')
      }).catch(() => {})

      // 静默处理，接口判断 if (error_code == 0){} else if (error_code){}
      return Promise.resolve({ data: {} })
    }
    
    if (response.status >= 500) {
      MessageBox.alert('服务器开小差了，刷新页面再试吧', {
        confirmButtonText: '确定',
      }).then(() => {
        location.reload()
      })
    }
    return response
  },
)

// 清除请求参数中 值位空的字符串
function clearData(data) {
  data = { ...data };
  Object.keys(data).forEach((key) => {
    if (data[key] === '') {
      delete data[key]
    }
  })
  return data
}

export const LOCAL_JSON_URL = isDEV ? '/json' : '/promote/dist/json'
const localJsonService = axios.create({
  baseURL: LOCAL_JSON_URL,
})
export function getLocalJSON(api) {
  return localJsonService.get(api)
}
